<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper default-page bg-white-imp">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <!-- <button @click="goBack()" class="button is-flex nav-back">
            <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back" />
          </button> -->
          <h1 class="title has-text-black">Help And Support</h1>
        </div>
      </app-header>
      <main class="content-wrapper bg-white-imp">
        <section class="section">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-8-tablet has-text-centered">
                <div class="mb30 has-text-centered">
                  <h3 class="title sf-pro-text-bold">Need Help?</h3>
                  <p class="is-size-14">
                    Our Client Success representatives are available from Mon - Fri from 9 am to 9 pm
                    <br />&amp; Sat-Sun from 9 am to 7 pm, to provide you with the answers you need.
                  </p>
                </div>

                <div class="mb30 has-text-centered">
                  <img src="../../assets/img/icon-phone.svg" alt="Call Us" class="mb5" />
                  <h3 class="title sf-pro-text-bold mb0">Call us directly:</h3>
                  <p class="is-size-14">
                    <a href="tel:1-877-490-0003p143">1-877-490-0003 Ext. 143</a>
                  </p>
                </div>

                <div class="mb30 has-text-centered">
                  <img src="../../assets/img/icon-email2.svg" alt="Email Us" class="mb5" />
                  <h3 class="title sf-pro-text-bold mb0">Email Us:</h3>
                  <p class="is-size-14 mb20">
                    <a href="mailto:support@shopley.com">support@shopley.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpAndSupport',
  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage', query: this.$route.query });
    },
  },
};
</script>

<style scoped>
.mt-2 {
  margin-top: 15px;
}
.mt-4 {
  margin-top: 30px;
}
li {
  margin-top: 15px;
  font-size: 0.875rem !important;
}
</style>